<template>
	<div class="">
		<Header></Header>
		<div>
			<div class="fenbg">
				<img src="../assets/home/bg4.png" alt="" height="225px">
			</div>
			<div class="detaltitle">
				<p>这是关于曲靖分校的某项介绍</p>
			</div>
			<div class="infomsg">
				<span>
					<img src="../assets/fenzhan/biao.png" alt="">
				</span>
				<span>
					2019-12-12
				</span>
				<span>
					<img src="../assets/fenzhan/dizhi.png" alt="">
				</span>
				<span>曲靖</span>
				<span>
					<img src="../assets/fenzhan/yj.png" alt="">
				</span>
				<span>
					628
				</span>
			</div>
			<div class="txtdetail w95">
				<p class="col666">
					旁边少女眼睛有些红肿，但仍用好奇目光打量着这位从未见过面的兄长。
					　　石牧望向大厅中间摆放的的黑色棺木，面色复杂。
					　　缟素妇人见此，也没有催促的意思。
					　　青衫拉老者则趁此机会上前几步，走到妇人面前低声说了几句什么，就无声的退了出去。
					　　好一会儿后，石牧终于脚步动了，慢慢走到棺木前，平静的说了一句：
					　　“打开盖子，我要见他最后一面。”
					　　“没问题”
					　　妇人“啪”“啪”拍了两下手。
					　　顿时从大厅两侧涌出两名大汉，将棺盖一推而开，露出里面静静躺着的一具男子来
					　　石牧低首看着棺木中和自己有六七相像的男子面容，脸色苍白了起来，半晌后才从腰间掏出一面看似普通的铜镜，默默的摆放在了男子身躯旁边
				</p>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Fenzhan',
		components: {
			Header,
			Fotter
		},
		data() {
			return {

			}

		},
		methods: {

		}
	}
</script>

<style scoped>
	.fenbg {
		width: 100%;
		height: 225px;
	}

	.fenbg img {
		width: 100%;
		height: 100%;
	}

	.detaltitle {
		margin: 20px auto;
	}

	.detaltitle p {
		text-align: center;
		font-size: 15px;
		;
		font-weight: 600;
		line-height: 21px;
		color: rgba(51, 51, 51, 1);
	}

	.infomsg {
		text-align: center;
	}

	.infomsg span {
		display: inline-block;
		text-align: center;
		margin: 5px 5px;
	}

	.infomsg span img {
		width: 15px;
		height: 15px;
	}

	.txtdetail {
		margin: 20px auto;
	}

	.txtdetail p {
		font-size: 12px;
		font-weight: 300;
		line-height: 23px;
	}
</style>



// WEBPACK FOOTER //
// src/components/FenDetail.vue